<div class="offeree-page-container">
  <div class="left-column">
    <div class="preview-section" *ngIf="selectedOffer">
      <div class="offer-preview">
        <div class="preview-header">
          <h4>{{ selectedOffer.name }}</h4>
        </div>
        <div class="preview-details">
          <div class="preview-row d-flex justify-content-between">
            <img class="logo-preview" src="{{ selectedOffer.logoUrl }}"/>
            <div class="version-info">
              <div class="version-number" *ngIf="currentVersion">
                <span class="value">#{{ currentVersion }}</span>
              </div>
              <div class="last-update" *ngIf="selectedOffer.lastUpdate">
                <span class="value">{{ selectedOffer.lastUpdate | date:'MM.dd.yyyy' }}</span>
              </div>
            </div>
          </div>
          <div class="detail-row">
            <span class="label">TO:</span>
            <span class="value">{{ selectedOffer.to }}</span>
          </div>
          <div class="detail-row">
            <span class="label">RE:</span>
            <span class="value">{{ selectedOffer.re }}</span>
          </div>
          <div class="detail-row">
            <span class="label">ESTIMATED PRICE:</span>
            <span class="total-value">{{ getTotalValue() | currency:'USD':'symbol':'1.0-0' }}</span>
          </div>
          <p class="preview-subtitle text-center">Please see below for the breakdown.</p>
        </div>

        <div class="preview-groups">
          <ng-container *ngFor="let group of getOfferGroups(selectedOffer)">
            <div class="preview-group" *ngIf="hasCustomerItems(group)">
              <h5 class="text-center" *ngIf="!shouldHideGroupName(group)">{{ group.name }}</h5>

              <table class="offer-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody *ngIf="isMaterialGroup(group)">
                <ng-container letIndex="index" *ngFor="let groupedSubGroup of getGroupedSubgroupsWithCustomerItems(group); let groupIdx = index">
                  <!-- Grouped Subgroup Header Row -->
                  <tr class="grouped-subgroup-header-row" (click)="toggleGroupedSubgroupCollapse(group, groupedSubGroup.name)" style="cursor:pointer;" *ngIf="!shouldHideSubgroupName(groupedSubGroup)">
                    <td colspan="5" class="grouped-subgroup-header">
                      <i class="material-icons" style="margin-right: 8px;">
                        {{ isGroupedSubgroupCollapsed(group, groupedSubGroup.name) ? 'chevron_right' : 'expand_more' }}
                      </i>
                      <strong>{{ groupedSubGroup.name }}</strong>
                    </td>
                  </tr>
                  <!-- Sub-subgroups within the grouped subgroup -->
                  <ng-container *ngFor="let subGroup of getSubgroupsWithCustomerItems(groupedSubGroup)">
                    <!-- Subgroup Header Row -->
                    <tr class="subgroup-header-row" [hidden]="isGroupedSubgroupCollapsed(group, groupedSubGroup.name)" *ngIf="!shouldHideSubgroupName(subGroup)">
                      <td colspan="2" class="subgroup-header">
                        {{ subGroup.name }}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <!-- Subgroup Items -->
                    <ng-container *ngFor="let item of getCustomerItems(subGroup)">
                      <tr [hidden]="isGroupedSubgroupCollapsed(group, groupedSubGroup.name) || isSubgroupCollapsed(group, subGroup.name)">
                        <td>{{ getMaterialItemIndex(group, groupedSubGroup, subGroup, item) + 1 }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.quantity }} {{ item.quantityDescription }}</td>
                        <td>{{ item.unitPrice | currency:'USD':'symbol':'1.0-1' }}</td>
                        <td>{{ item.totalPrice | currency:'USD':'symbol':'1.0-1' }}</td>
                      </tr>
                    </ng-container>
                  </ng-container>
                  <!-- Grouped Subgroup Subtotal Row -->
                  <tr [hidden]="isGroupedSubgroupCollapsed(group, groupedSubGroup.name)" *ngIf="!shouldHideSubgroupName(groupedSubGroup)">
                    <td colspan="4" class="grouped-subgroup-subtotal-label"><strong>{{ groupedSubGroup.name }} SUBTOTAL</strong></td>
                    <td class="grouped-subgroup-subtotal-value">
                      <strong>{{ getGroupedSubgroupSubtotal(groupedSubGroup) | currency:'USD':'symbol':'1.0-1' }}</strong>
                    </td>
                  </tr>
                </ng-container>
                <!-- Group Total Row -->
                <tr class="group-total-row">
                  <td colspan="4" class="group-total-label">TOTAL</td>
                  <td class="group-total-value">{{ getGroupTotal(group) | currency:'USD':'symbol':'1.0-1' }}</td>
                </tr>
              </tbody>

              <!-- Non-material group -->
              <tbody *ngIf="!isMaterialGroup(group)">
                <tr *ngFor="let item of getAllCustomerItemsFlat(group); let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.unitPrice | currency:'USD':'symbol':'1.0-1' }}</td>
                  <td>{{ item.totalPrice | currency:'USD':'symbol':'1.0-1' }}</td>
                </tr>
                <!-- Group Total Row -->
                <tr class="group-total-row">
                  <td colspan="4" class="group-total-label">TOTAL</td>
                  <td class="group-total-value">{{ getGroupTotal(group) | currency:'USD':'symbol':'1.0-1' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          </ng-container>
        </div>

      </div>
    </div>
  </div>

  <div class="right-column">
    <div class="preview-notes" *ngIf="notes">
      <span class="label">Notes:</span>
      <p>{{ notes }}</p>
    </div>

    <div class="action-buttons-top-container">
      <div class="action-buttons-top">
        <button class="btn rounded-circle btn-bom" ngbTooltip="Export to PDF" (click)="exportSelectedOfferToPdf()">
          <div class="icon icon-pdf"></div>
        </button>
        <!-- <button class="btn rounded-circle btn-bom" ngbTooltip="3D Viewer">
          <div class="icon icon-3dView"></div>
        </button> -->

      </div>
    </div>

    <div class="decision-buttons">
      <!-- Show current status if decision has been made -->
      <div class="status-message" *ngIf="hasOffereeMadeDecision()">
        <div class="alert" [ngClass]="{
          'alert-success': getCurrentOffereeStatus() === 'ACCEPTED',
          'alert-danger': getCurrentOffereeStatus() === 'REJECTED'
        }" role="alert">
          <strong>Status:</strong>
          <span *ngIf="getCurrentOffereeStatus() === 'ACCEPTED'">Quote Accepted</span>
          <span *ngIf="getCurrentOffereeStatus() === 'REJECTED'">Quote Rejected</span>
        </div>
      </div>

      <!-- Show action buttons only if no decision has been made -->
      <div class="action-buttons-row" *ngIf="!hasOffereeMadeDecision()">
        <button
          class="btn btn-primary accept-offer-btn"
          (click)="acceptOffer()"
          [disabled]="acceptingOffer || rejectingOffer || !selectedOffer">
          <i *ngIf="acceptingOffer" class="bi bi-arrow-clockwise spin"></i>
          <span *ngIf="!acceptingOffer">Accept Quote</span>
          <span *ngIf="acceptingOffer">Accepting...</span>
        </button>
        <button
          class="btn btn-secondary reject-offer-btn"
          (click)="rejectOffer()"
          [disabled]="acceptingOffer || rejectingOffer || !selectedOffer">
          <i *ngIf="rejectingOffer" class="bi bi-arrow-clockwise spin"></i>
          <span *ngIf="!rejectingOffer">Reject Quote</span>
          <span *ngIf="rejectingOffer">Rejecting...</span>
        </button>
      </div>
    </div>

    <div class="comment-section">
      <span class="label">Write a comment to client:</span>
      <div class="comment-input-row">
        <textarea
          class="form-control comment-input text-top"
          placeholder="Enter your comment..."
          [(ngModel)]="commentText"
          [disabled]="sendingComment">
        </textarea>
      </div>
      <div class="send-comment-container">
        <button
          class="btn btn-primary send-comment-btn"
          ngbTooltip="Send Message"
          (click)="sendComment()"
          [disabled]="!commentText.trim() || sendingComment">
          <i *ngIf="!sendingComment" [class.disabled]="!commentText.trim() || sendingComment"></i>
          <span *ngIf="!sendingComment">Send Comment</span>
          <span *ngIf="sendingComment">Sending...</span>
        </button>
      </div>
    </div>

    <div class="error-message" *ngIf="error">
      <div class="alert alert-danger" role="alert">
        {{ error }}
      </div>
    </div>

    <div class="success-message" *ngIf="successMessage">
      <div class="alert alert-success" role="alert">
        {{ successMessage }}
      </div>
    </div>

    <div class="form-group text-center mt-3">
      <div class="form-text">
        Don't have an account yet?
        <button class="form-link" routerLink="/home">About Builtgenix</button>
      </div>
    </div>
  </div>
</div>
